export default __webpack_public_path__ + "static/media/abracadabra-logo.6b1af7e5.svg";